import { api } from '../client';

import type { ListResponse, PaginationParams } from './common';

export interface StockMaterial {
  id: string;
  name: string;
  unit_code: string;
  is_weighted: boolean;
  ownership: 'ingredient' | 'supply';
  category_id?: string | null;
  category_name?: string | null;
  default_cost?: string | null;
  last_unit_cost?: string | null;
  last_purchase_at?: string | null;
  is_active: boolean;
  recipes_count?: number | null;
  can_hard_delete?: boolean | null;
  created_at?: string | null;
  updated_at?: string | null;
}

export interface MaterialListSummary {
  by_status: Record<string, number>;
}

export interface StockMaterialsResponse extends ListResponse<StockMaterial> {
  summary?: MaterialListSummary | null;
}

export interface StockMaterialFilters extends PaginationParams {
  [key: string]: string | number | boolean | undefined;
  ownership?: string;
  is_active?: boolean;
  category_id?: string;
  search?: string;
  include_summary?: boolean;
}

export const createStockMaterialsApi = () => ({
  list: async (filters: StockMaterialFilters = {}): Promise<StockMaterialsResponse> => {
    return api.webAdmin.get<StockMaterialsResponse>('/stock/materials', { params: filters });
  },
});
